/* Campaign-style lazy video playback. A custom element also reconnects after
   collection filtering and theme-editor section reloads. */
if (!customElements.get('collection-promo')) {
  customElements.define('collection-promo', class extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('template')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          let video = this.querySelector('video');
          if (entry.isIntersecting && !video && !this.dataset.autoplayBlocked) {
            const template = this.querySelector('template');
            // Create media in the active document; Safari can leave template clones inert.
            video = document.importNode(template.content.querySelector('video'), true);
            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;
            video.autoplay = true;
            video.preload = 'metadata';
            template.parentElement.appendChild(video);
          }
          if (!video) return;
          if (entry.isIntersecting) {
            video.play().catch((error) => {
              // Autoplay refused (iOS Low Power Mode etc.): remove the video so the
              // poster behind it shows again, and stop re-cloning on later passes.
              // AbortError (pause() racing a pending play()) is routine — ignore it.
              if (!error || error.name !== 'NotAllowedError') return;
              this.dataset.autoplayBlocked = 'true';
              video.remove();
            });
          } else {
            video.pause();
          }
        });
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.querySelector('video')?.pause();
    }
  });
}
